const tooltip = "_tooltip_6ode6_8";
const invisible = "_invisible_6ode6_21";
const caption = "_caption_6ode6_28";
const arrow = "_arrow_6ode6_33";
const styles = {
  tooltip,
  invisible,
  caption,
  arrow
};
export {
  arrow,
  caption,
  styles as default,
  invisible,
  tooltip
};
//# sourceMappingURL=Tooltip.module.css.js.map
